import { Box, Text } from '@skin-seoul/design-system';
import { useProductCard } from '../ProductCardContext';
import { decodeHTMLEntities } from '@skin-seoul/utils';
import { CLASSNAME } from '@skin-seoul/service';
import type { ComponentProps } from 'react';
type ProductCardInfoNameProps = {
  brandProps?: ComponentProps<typeof Text>;
  nameProps?: ComponentProps<typeof Text>;
};
const ProductCardInfoName = ({
  brandProps,
  nameProps
}: ProductCardInfoNameProps) => {
  const {
    theme = 'light',
    brand,
    name,
    orientation
  } = useProductCard();
  return <Box display="flex" flexDirection="column" gap="4px" width="100%" minWidth={0} data-sentry-element="Box" data-sentry-component="ProductCardInfoName" data-sentry-source-file="ProductCardInfoName.tsx">
      <Text textStyle="label.medium" fontWeight="semibold" lineClamp={1} pr={orientation === 'horizontal' ? 5 : undefined} color={theme === 'dark' ? 'neutral.100' : 'neutral.700'} className={CLASSNAME.NOT_TRANSLATE} {...brandProps} data-sentry-element="Text" data-sentry-source-file="ProductCardInfoName.tsx">
        {decodeHTMLEntities(brand)}
      </Text>
      <Text textStyle="paragraph.small" color={theme === 'dark' ? 'neutral.100' : 'neutral.500'} lineClamp={1} className={CLASSNAME.NOT_TRANSLATE} {...nameProps} data-sentry-element="Text" data-sentry-source-file="ProductCardInfoName.tsx">
        {decodeHTMLEntities(name)}
      </Text>
    </Box>;
};
export default ProductCardInfoName;